module.exports = __webpack_public_path__ + "static/media/show.0bf332de.svg";